import moment, { MomentInput } from "moment-timezone";
import { TIME_RANGE_TYPE } from "../../../../../contexts/CalendarTimeContext";

/**
 * Get default time range in number value arrays by timezone and type.
 * The baseline would be today's date.
 */
export default function getTimeRange(
  timezone: string,
  timeRangeType: TIME_RANGE_TYPE,
  startDateValue: MomentInput,
) {
  switch (timeRangeType) {
    case "day":
      return [
        moment(startDateValue).tz(timezone).startOf("day").valueOf(),
        moment(startDateValue).tz(timezone).endOf("day").valueOf(),
      ];
    case "threeDays":
      return [
        moment(startDateValue).tz(timezone).startOf("day").valueOf(),
        moment(startDateValue)
          .tz(timezone)
          .add(2, "days")
          .endOf("day")
          .valueOf(),
      ];
    case "week":
      return [
        moment(startDateValue).tz(timezone).startOf("week").valueOf(),
        moment(startDateValue).tz(timezone).endOf("week").valueOf(),
      ];
    case "month":
      return [
        moment(startDateValue)
          .tz(timezone)
          .startOf("month")
          .startOf("week")
          .valueOf(),
        moment(startDateValue)
          .tz(timezone)
          .endOf("month")
          .endOf("week")
          .valueOf(),
      ];
  }
}
